<template>
  <v-dialog v-model="modelOrder" v-on:update:modelValue="fechar" :scrollable="true">
    <v-btn icon="mdi-close" size="x-small" class="btn-close" @click="fechar"></v-btn>
    <v-card>
      <v-card-title class="px-6 py-4">
        <v-row class="d-flex flex-wrap align-center justify-space-between">
          <v-col cols="12" sm="auto" class="d-flex align-center justify-start mb-2 mb-sm-0">
            <h1 class="text-color-1 text-xxlarge">Informações do Pedido</h1>
          </v-col>
          <v-col cols="12" sm="auto" class="d-flex align-center justify-sm-end justify-center flex-wrap" v-if="loadingOrder == false && order != null">
            <v-skeleton-loader :loading="loadingOrder" type="button, button" class="d-flex flex-column flex-sm-row align-center justify-center justify-sm-end w-100">
              <v-btn v-if="order.status === 'Pedido finalizado pelo usuário'" variant="flat" class="bg-color-red text-color-white me-2 mb-2" @click="cancelarPedido()">Cancelar Pedido</v-btn>  
              <v-btn variant="flat" class="bg-color-2 text-color-white me-2 mb-2" @click="avaliarPedido(order.order_id)" v-if="order.is_valid_nps == 0 && order.is_answered == 0">Avaliar</v-btn>
              <v-btn v-if="order.is_able_repeat == 1" variant="flat" class="bg-color-2 text-color-white mb-2" @click="refazerPedido()">Refazer Pedido</v-btn>
            </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-card-title>
      <hr class="fine-line">
      <v-card-text class="pa-0" v-if="loadingOrder">
        <div class="px-6 py-4" style="height: 80vh">
          <v-skeleton-loader type="text, text, text, text, text" width="100%" class="with-margin"></v-skeleton-loader>
          <v-skeleton-loader type="text, text, text, text, text" width="100%" class="with-margin"></v-skeleton-loader>
        </div>
      </v-card-text>
      <v-card-text class="pa-0" v-else-if="loadingOrder == false && order != null">
        <div class="px-6 py-4">
          <v-row>
            <v-col cols="4">
              <b class="text-color-black">Número do Pedido:</b>
            </v-col>
            <v-col cols="8">
              <span class="text-color-0">{{ order.order_id }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <b class="text-color-black">Data do Pedido:</b>
            </v-col>
            <v-col cols="8">
              <span class="text-color-0">{{ $formatDate(order.finish_date+" 00:00:00") }} {{ order.finish_hour }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <b class="text-color-black">CPF na nota?</b>
            </v-col>
            <v-col cols="8">
              <span class="text-color-0">{{ order.is_nf == 1 ? "Sim": "Não" }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <b class="text-color-black">Status do Pedido:</b>
            </v-col>
            <v-col cols="8">
              <span class="text-color-0">{{ order.status }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <b class="text-color-black">Forma de Pagamento:</b>
            </v-col>
            <v-col cols="8">
              <span class="text-color-0" v-if="order.is_online_payment == 1">Pagamento Online - {{ order.payment_method }}</span>
              <span class="text-color-0" v-else>{{ order.payment_method }}</span>
            </v-col>
          </v-row>
          <v-row v-if="order.is_online_payment == 1 && order.payment_method == 'Pix' && pix != null">
            <v-col cols="2">
              <v-img :src="pix.qr_code_base64"></v-img>
            </v-col>
            <v-col cols="10">
              Copia e Cola:<br>
              <b @click="copiarTexto()" style="cursor: copy; word-break: break-word;">{{ pix.pix_copy_paste }}</b> <v-chip v-if="copiado" size="x-small" color="green" variant="flat">Copiado!</v-chip>
              <br><br>
              Após o pagamento, favor enviar o comprovante para o número de Whatsapp: <b>{{ pix.contact_phone }}</b>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="4">
              <b class="text-color-black">Valor de Cashback a Receber:</b>
            </v-col>
            <v-col cols="8">
              <span class="text-color-0">R$ 0,70</span>
            </v-col>
          </v-row> -->
          <v-row v-if="order.obs != ''">
            <v-col cols="12">
              <b class="text-color-black">Observação do Pedido:</b>
            </v-col>
            <v-col cols="12 pt-0">
              <span class="text-color-0">{{ order.obs }}</span>
            </v-col>
          </v-row>
        </div>
        <hr class="fine-line" v-if="order.coupons != null && order.coupons.length > 0">
        <div class="px-6 py-4" v-if="order.coupons != null && order.coupons.length > 0">
          <v-row>
            <v-col cols="12">
              <b class="text-color-black">Cupons aplicados:</b>
            </v-col>
            <v-col class="v-col-12 d-flex flex-wrap align-center justify-start py-0">
              <div v-for="coupon in order.coupons" :key="coupon" class="position-relative mb-3 mr-2">
                <span class="text-uppercase cupom mr-3 rounded">{{ coupon }}</span>
              </div>
            </v-col>
          </v-row>
        </div>
        <hr class="fine-line">
        <div class="px-6 py-4">
          <v-row>
            <v-col cols="8">
              <b class="text-color-black">Dados de entrega:</b><br>
              <span v-if="order.nickname != '' && order.nickname != null" class="text-color-0 font-weight-bold">
                {{ order.nickname }}<br>
              </span>
              <span class="text-color-0">
                {{ order.zip_code }} | {{ order.street }}, {{ order.number }} - {{ order.district }} - {{ order.city }}/{{ order.state }}
              </span>
              <span v-if="order.complement != ''" class="text-color-0">
                <br>{{ order.complement }}
              </span>
            </v-col>
            <v-col cols="4">
              <b class="text-color-black">Horário:</b><br>
              <span class="text-color-0">{{ $formatDate(order.delivery_date+" 00:00:00") }} <br>Entre {{ order.delivery_ihour.split(":")[0]+"h"+order.delivery_ihour.split(":")[1] }} e {{ order.delivery_fhour.split(":")[0]+"h"+order.delivery_fhour.split(":")[1] }}</span>
            </v-col>
          </v-row>
        </div>
        <hr class="fine-line">
        <div class="px-6 py-4">
          <v-row v-if="order.value != order.total_final">
            <v-col cols="8">
              <b class="text-color-black">Soma dos Itens:</b>
            </v-col>
            <v-col cols="4" class="text-end">
              <span class="text-color-0"> {{ $formatNumber(order.value, {style: 'currency', currency: 'BRL'}) }} </span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <b class="text-color-black">Frete:</b>
            </v-col>
            <v-col cols="4" class="text-end">
              <span class="text-color-0" v-if="order.shipping_fee > 0">+ {{ $formatNumber(order.shipping_fee, {style: 'currency', currency: 'BRL'}) }} </span>
              <span class="text-color-green" v-else>Grátis</span>
            </v-col>
          </v-row>
          <v-row v-if="order.value_discounts > 0">
            <v-col cols="8">
              <b class="text-color-black">Descontos:</b>
            </v-col>
            <v-col cols="4" class="text-end">
              <span class="text-color-green">- {{ $formatNumber(order.value_discounts, {style: 'currency', currency: 'BRL'}) }}</span>
            </v-col>
          </v-row>
          <v-row v-if="order.wallet_value > 0">
            <v-col cols="8">
              <b class="text-color-black">Carteira Digital:</b>
            </v-col>
            <v-col cols="4" class="text-end">
              <span class="text-color-green">- {{ $formatNumber(order.wallet_value, {style: 'currency', currency: 'BRL'}) }}</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8">
              <b class="text-color-black text-xlarge">Valor do Pedido:</b>
            </v-col>
            <v-col cols="4" class="text-end">
              <b class="text-color-0 text-xlarge">{{ $formatNumber(order.total_final, {style: 'currency', currency: 'BRL'}) }}</b>
            </v-col>
          </v-row>
        </div>
        <v-row class="px-0 mx-0 my-0 overflow-y-auto">
          <v-col class="pa-0 d-flex align-center justify-center flex-wrap">
            <v-list class="w-100 pa-0 ma-0 br-0" v-for="i in order.itens" :key="i.category">
              <v-list-item class="bg-color-gray text-color-0 text-start py-0 text-small">{{ i.category }} ({{ i.qtd }} {{ i.qtd > 1 ? ' itens':' item' }})</v-list-item>
              <v-list-item v-for="(p, index) in i.itens" :key="index" class="border-bottom list-cart" :class="(index%2) == 0 ? 'bg-white':'bg-color-lightgray'">
                <v-row class="ma-0">
                  <v-col class="v-col-1 d-flex align-center justify-center cursor-pointer pa-0">
                    <ImageProduct :image="p.image"></ImageProduct>
                  </v-col>
                  <v-col class="v-col-5 v-col-md-7 text-color-0 text-small d-flex align-center justify-start">
                    {{ p.name }}
                  </v-col>
                  <v-col class="v-col-3 v-col-md-2 text-color-0 text-small d-flex align-center justify-end">
                    {{ p.is_kg == 1 ? textQtd(p.amount) : textUnd(p.amount) }}
                  </v-col>
                  <v-col class="v-col-3 v-col-md-2 text-color-0 text-small d-flex align-center justify-end">
                    {{ $formatNumber(p.total_price, {style: 'currency', currency: 'BRL'}) }}
                  </v-col>
                  <v-col v-if="p.obs != ''" class="v-col-12 text-color-0 text-small d-flex align-center justify-start">
                    {{ p.obs }}
                  </v-col>
                </v-row>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import ImageProduct from '@/components/ImageProduct.vue';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
  name: 'DialogOrder',
  components: {
    ImageProduct
  },
  data(){
    return {
      modelOrder: false,
      order: null,
      pix: null,
      copiado: false
    }
  },
  props: {
    id: {
      type: Number,
      default: null
    },
    model: {
      type: Boolean,
      default: false
    },
    fechar: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapState('order', {
      loadingOrder: 'loadingOrder'
    }),
    ...mapGetters('main', {
      getConfig: 'getConfig'
    }),
  },
  watch: {
    model() {
      this.modelOrder = this.model;
      this.order = null;
      this.pix = null;
      this.copiado = false;
    },
    id(id) {
      if(id != null){
        this.getOrderDetails(id).then(function(response){
          if(response.cod == 100){
            this.order = response.return;
            let orders = [];
            if(this.order.is_online_payment == 1 && this.order.payment_method == 'Pix'){
              this.getPix({order_id: id}).then(function(retorno){
                this.pix = retorno;
              }.bind(this));
            }
            this.order.itens.forEach(element => {
              this.getImageCarousel({ imghash: element.imghash }).then(function(image){
                element.image = image;
              }.bind(this));
              const cat = orders.find(c => c.category == element.category);
              if(cat){
                cat.itens.push(element);
                cat.total += element.total_price;
                cat.qtd += 1;
              } else {
                orders.push({
                  category: element.category,
                  itens: [element],
                  qtd: 1
                });
              }
            });
            this.order.itens = orders;
            this.order.total_final = this.order.value + this.order.shipping_fee - this.order.wallet_value - this.order.value_discounts;
          } else {
            this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg });
            this.fechar();
          }
        }.bind(this));
      } else {
        this.order = null;
      }
    }
  },
  methods: {
    ...mapActions('order', {
      getOrderDetails: 'getOrderDetails',
      orderRepeat: 'orderRepeat',
      cancelOrder: 'cancelOrder',
      getPix: 'getPix'
    }),
    ...mapActions('products', {
      getImageCarousel: 'getImageCarousel'
    }),
    ...mapActions('main', {
      changeStore: 'changeStore'
    }),
    copiarTexto() {
      navigator.clipboard.writeText(this.pix.pix_copy_paste).then(() => {
        this.copiado = true;
      });
    },
    cancelarPedido() {
      this.emitter.emit('dialogMessage', {
        title: "Atenção!",
        message: "Você tem certeza que deseja cancelar este pedido?<br>Esta ação não poderá ser desfeita.",
        response: this.cancelarPedidoAction
      });
    },
    cancelarPedidoAction(confirmado) {
      if (confirmado) {
        this.cancelOrder(this.id).then(response => {
          if (response.cod === 100 || response.cod === 200 || response.cod === 201) {
            this.emitter.emit('dialogMessage', {
              title: "Sucesso!",
              message: response.msg,
              fechar: () => { 
                this.fechar();
                this.$router.go()
            }
            });
          } else {
            this.emitter.emit('dialogMessage', {
              title: "Ops!",
              message: response.msg
            });
          }
        });
      }
    },
    refazerPedido(){
      let msgloja = "";
      if(this.order.store_id != this.getConfig.store){
        msgloja = " Esse pedido foi feito em outra de nossas unidades, ao refazê-lo você será redirecionado para ela.";
      }
      this.emitter.emit('dialogMessage', { 
        title: "Atenção!", 
        message: "Esta ação está sujeita a disponibilidade dos produtos e é possível que os preços não sejam mantidos.<br>Refazer esse pedido limpa o carrinho atual."+msgloja+"<br>Tem certeza que deseja continuar?", 
        response: this.refazerPedidoAction });
    },
    refazerPedidoAction: function(r){
      if(r){
        if(this.order.store_id != this.getConfig.store){
          this.changeStore(this.order.store_id).then(function(){
            this.orderRepeat(this.id).then(function(response){
              if(response.cod == 200 || response.cod == 201){
                this.emitter.emit('dialogMessage', { title: "Sucesso!", message: response.msg, fechar: () => { this.$router.push("/"); } });
              } else {
                this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg});
              }
            }.bind(this));
          }.bind(this));
        } else {
          this.orderRepeat(this.id).then(function(response){
            if(response.cod == 200 || response.cod == 201){
              this.emitter.emit('dialogMessage', { title: "Sucesso!", message: response.msg, fechar: () => { this.$router.push("/"); } });
            } else {
              this.emitter.emit('dialogMessage', { title: "Ops!", message: response.msg});
            }
          }.bind(this));
        }
      }
    },
    avaliarPedido(id){
      this.emitter.emit('dialogNPS', { order_id: id });
      this.fechar();
    },
    textQtd: function (qtd) {
      if (qtd < 1) {
          return Number(Math.round((qtd * 1000) + 'e0') + 'e-0')+'g';
      } else {
          return Number.isInteger(qtd) ? (Number(Math.round((qtd) + 'e0') + 'e-0')+'kg').replace(".", ",") : (Number(Math.round((qtd) + 'e3') + 'e-3').toFixed(3)+'kg').replace(".", ",")
      }
    },
    textUnd: function (qtd) {
      if (qtd == 1) {
          return qtd + ' und';
      } else {
          return qtd + ' unds';
      }
    },
  }
}
</script>